import { createApp } from "vue";
import App from "./App.vue";
// import "./registerServiceWorker";
import router from "./router";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { store } from "./store";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import { faLock, faSync, faSearch } from "@fortawesome/free-solid-svg-icons";
import i18n from "./i18n";
import Keycloak from "keycloak-js";
import { keycloakOptions, KeycloakUtil } from "./utils/keycloak";

// Importing the global css files
import "@/assets/css/main.scss";
import "@/assets/css/responsive.scss";

// Exporting keycloak, thus allowing to access the instance in non-vue files (e.g. ApiService.ts).
export const keycloak = new KeycloakUtil();

async function initApp() {
  // Font-awesome initialization
  library.add(
    faPaperPlane as any,
    faLock as any,
    faSync as any,
    faSearch as any
  );

  const app = createApp(App);
  const keycloakInstance = Keycloak(keycloakOptions);

  await keycloakInstance.init({
    checkLoginIframe: false
  });

  keycloak.init(keycloakInstance);
  // Makes keycloak available in each component. The provide also allows for the keycloak instance to get injected in components.
  app.config.globalProperties.$keycloak = keycloak;
  app.provide("keycloak", keycloak);

  app
    .use(store)
    .use(i18n)
    .use(router)
    .component("fa", FontAwesomeIcon)
    .mount("#app");
}

initApp();
